<template>
  <div
    :class="{ 'has-danger': error }"
    class="form-group row">
    <label
      :for="labelId"
      class="col-4 col-form-label">{{labelText}}
      <span
        class="text-danger"
        v-if="inputRequire">*</span>
    </label>
    <div class="col-8">
      <input
        :id="labelId"
        :value="value"
        class="form-control"
        :type="inputType"
        autocomplete="off"
        @input="changeValue($event.target.value)">
      <span
        v-if="error"
        class="small help-block text-danger">{{errorText}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AdminFormInput',
    props: {
      value: {
        type: [String, Number],
        default: null
      },
      error: {
        type: Boolean,
        default: false
      },
      inputRequire: {
        type: Boolean,
        default: false
      },
      errorText: {
        type: String,
        default: 'Неправильно заполнено поле'
      },
      labelText: {
        type: String,
        default: ''
      },
      labelId: {
        type: String,
        default: 'label' + Math.random()
      },
      inputType: {
        type: String,
        default: 'text'
      }
    },
    methods: {
      changeValue (val) {
        this.$emit('input', this.inputType === 'text' ? val : parseInt(val))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AdminFormInput.vue?6ce9f4aa